
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AuthHeader from '@/components/auth/AuthHeader';
import LoginForm from '@/components/auth/LoginForm';
import RegisterForm from '@/components/auth/RegisterForm';
import { useAuth } from '@/context/AuthContext';

const Auth = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const from = (location.state as any)?.from?.pathname || '/dashboard';
  const defaultTab = searchParams.get('tab') || 'login';

  const [activeTab, setActiveTab] = useState(defaultTab);
  const { user } = useAuth();

  useEffect(() => {
    // Met à jour l'onglet actif quand l'URL change
    setActiveTab(searchParams.get('tab') || 'login');
  }, [searchParams]);

  // Redirect if already logged in
  useEffect(() => {
    if (user) {
      navigate(from, { replace: true });
    }
  }, [user, navigate, from]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="w-full max-w-md">
        <AuthHeader />

        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-2 mb-8">
            <TabsTrigger value="login">Connexion</TabsTrigger>
            <TabsTrigger value="register">Inscription</TabsTrigger>
          </TabsList>

          <TabsContent value="login">
            <LoginForm redirectPath={from} />
          </TabsContent>

          <TabsContent value="register">
            <RegisterForm redirectPath={from} />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default Auth;
